module.exports = __webpack_public_path__ + "img/practice.d8a471bd.png";